(function (root, factory) {
  const engine = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = engine;
  } else {
    root.SkinQuizEngine = engine;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  const PRODUCT_ORDER = [
    'deep_clean',
    'mild_clean',
    'nurturing_cleanser',
    'aha_bha_cleanser',
    'multi_b',
    'intensive_c',
    'exfol_a',
    'optiboost',
    'penta_hydration',
    'redless',
    'ceramide',
    'complete_pigment',
    'absolute_corrective',
    'resveratrol',
    'hydra_shield',
    'ultra_light',
  ];

  const TREATMENT_ORDER = [
    'skinpen_nctf',
    'glass_facial',
    'rejuran_injections',
    'skinpen_rejuran_booster',
    'skinpen_byryzn',
  ];

  const CONSULTATION_ORDER = ['wrinkle_reduction', 'liftera_hifu', 'volume_replenishment', 'pregnancy_safe'];

  const AGE_PRODUCTS = {
    '18_29': ['multi_b', 'intensive_c'],
    '30_39': ['multi_b', 'intensive_c'],
    '40_49': ['exfol_a', 'multi_b', 'intensive_c'],
    '50_plus': ['multi_b', 'optiboost'],
  };

  const SKIN_TYPE_RULES = {
    normal: {
      products: ['deep_clean', 'penta_hydration', 'resveratrol'],
      treatments: ['skinpen_nctf'],
    },
    sensitive: {
      products: ['mild_clean', 'redless', 'hydra_shield'],
      treatments: ['glass_facial'],
    },
    dry: {
      products: ['nurturing_cleanser', 'ceramide', 'resveratrol'],
      treatments: ['rejuran_injections'],
    },
    oily_acne: {
      products: ['aha_bha_cleanser', 'multi_b', 'ultra_light'],
      treatments: ['skinpen_rejuran_booster'],
    },
    combination: {
      products: ['mild_clean', 'multi_b', 'ultra_light'],
      treatments: ['skinpen_rejuran_booster'],
    },
  };

  function addAll(target, values) {
    values.forEach((value) => target.add(value));
  }

  function sortByOrder(values, order) {
    return order.filter((value) => values.has(value));
  }

  function evaluate(answers) {
    const products = new Set();
    const treatments = new Set();
    let consultations = new Set();

    addAll(products, AGE_PRODUCTS[answers.age] || []);

    const skinRule = SKIN_TYPE_RULES[answers.skinType];
    if (skinRule) {
      addAll(products, skinRule.products);
      addAll(treatments, skinRule.treatments);
    }

    if (answers.pigmentation === 'yes') products.add('complete_pigment');

    if (answers.deepWrinkles === 'yes') {
      treatments.add('skinpen_byryzn');
      consultations.add('wrinkle_reduction');
    }

    if (answers.sagging === 'yes') {
      treatments.add('skinpen_byryzn');
      consultations.add('liftera_hifu');
    }

    if (answers.adultAcne === 'yes') products.add('exfol_a');

    if (answers.hollowing === 'yes') consultations.add('volume_replenishment');

    if (answers.skinType === 'sensitive') {
      products.delete('exfol_a');
      products.delete('intensive_c');
    }

    if (answers.skinType === 'dry') products.delete('exfol_a');

    if (answers.pregnancy === 'yes') {
      products.delete('exfol_a');
      products.delete('deep_clean');
      products.delete('aha_bha_cleanser');
      products.delete('absolute_corrective');
      treatments.clear();
      consultations = new Set(['pregnancy_safe']);
    }

    return {
      products: sortByOrder(products, PRODUCT_ORDER),
      treatments: sortByOrder(treatments, TREATMENT_ORDER),
      consultations: sortByOrder(consultations, CONSULTATION_ORDER),
      warning: answers.pregnancy === 'yes' ? 'pregnancy' : null,
    };
  }

  return {
    evaluate,
    productOrder: PRODUCT_ORDER.slice(),
    treatmentOrder: TREATMENT_ORDER.slice(),
    consultationOrder: CONSULTATION_ORDER.slice(),
  };
});
